import React from 'react';
import { Tooltip } from 'react-tooltip'

type TooltipProps = {
    trigger: React.ReactNode;
    message: string;
};

const TooltipWrapper = ({ message, trigger }: TooltipProps) => {
    const uuid = crypto.randomUUID();
    const overloadedTrigger = React.cloneElement(trigger as React.ReactElement, { 
        'data-tooltip-id': uuid,
        'data-tooltip-content': message,
        'data-tooltip-place': 'top'
    })

    return (
        <div>
            {overloadedTrigger}
            <Tooltip id={uuid} />
        </div>
    )
}

export default TooltipWrapper;

